export default "__VITE_ASSET__DH$vizwr__"